/*! Texelwire — 0.1.6 - MIT license */

/**
 * Escape HTML
 */
String.prototype.escapeHTML = function() {
	
    return this.replace(/&/g, "&amp;")
               .replace(/</g, "&lt;")
               .replace(/>/g, "&gt;")
               .replace(/"/g, "&quot;")
               .replace(/'/g, "&#039;");
                   
}


/**
 * Pseudo form
 */
$('div.pseudo-form').each(function() {

	var $this = $(this);

	// Add the form tag
	var $form = $this.wrap('<form></form>')
	                 .closest('form');

	// Get the attributes
	var formAttr = $this.data('cubed-form-inner');

	// Add the attributes
	var attributes = $this.prop('attributes');
	
	console.log($this.data());

	// Copy over attributes
	$.each(attributes, function() {
		
	    $form.attr(this.name, this.value);
		
	});
	
	// Copy method and action and remove data- counterparts
	$form.attr('method', $this.data('method'));
	$form.attr('action', $this.data('action'));
	$form.attr('data-method', null);
	$form.attr('data-action', null);

	// Get rid of the dummy tag
	$this.replaceWith($this.children());
					 
});


/**
 * Validate email
 */
function validateEmail(email) {
	
	var regex = /\S+@\S+\.\S+/;
	
	return regex.test(email);
		
}


/**
 * Form validation
 */
$('form.validate').on('submit', function() {

    var isValid     = true;
    var alertMsg    = '';

    $(this).find('textarea, input[type="text"]')
           .each(function() {

        var $this = $(this);

        $this.removeClass('required');

        if ($this.data('required-message') && $this.val() === '') {

            isValid = false;

            $this.addClass('required');

            alertMsg += $this.data('required-message');
            alertMsg += '\n';

        }
		
		if ($this.data('required-message-email') && validateEmail($this.val()) === false && $this.val() !== '') {
			
			isValid = false;

            $this.addClass('required');

            alertMsg += $this.data('required-message-email');
            alertMsg += '\n';
			
		}

    });

    if (isValid === false) {

        alert(alertMsg);

    }

    return isValid;

});


/**
 * Videos
 */
window.reflowVideo = function($iframe) {

	if ($iframe.data('video-aspect-ratio') && $iframe.prop('tagName').toLowerCase() == 'iframe') {

		var dimensions 	= $iframe.data('video-aspect-ratio');
		dimensions 		= dimensions.split(':');

		var newHeight 	= ($iframe.width() / dimensions[0]) * dimensions[1];
		newHeight		= parseInt(newHeight);

		$iframe.css('height', newHeight + 'px');

	}

};

window.reflowVideos = function() {

	$('iframe').each(function() {

		window.reflowVideo($(this));

	});

}

$(window).on('resize', function() {

	window.reflowVideos();

}).trigger('resize');


/**
 * Trigger window load after a time
 * (in case third-party scripts delay event and therefore local scripts that reply in window loaded)
 *
 * Defaults to 5 seconds, can be overridden using body[data-loaded-handler-timeout]
 * Set to 0 to disable
 */
window.loadedHandlerCalled = false;

var loadedHandlerTimeout = typeof $('body').data('loaded-handler-timeout') == 'undefined' ? 5000 : parseInt($('body').data('loaded-handler-timeout'));

if (loadedHandlerTimeout != 0) {

	$(window).on('load', function() {
	     
	    window.loadedHandlerCalled = true;
	     
	});
	 
	setTimeout(function() {
	     
	    if (window.loadedHandlerCalled === false) {
	 
	         window.dispatchEvent(new Event('load'));
	        
	    }
	 
	}, loadedHandlerTimeout);

}
